export default __webpack_public_path__ + "static/media/deleteLoading.99162b2e.svg";